import React from 'react';
import ReactDOM from 'react-dom';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

import { ConfigProvider } from 'antd';
// import ptBR from 'antd/lib/locale-provider/pt_BR';
import viVN from 'antd/es/locale/vi_VN';
import 'moment/locale/vi';

import App from './App';
import * as serviceWorker from './serviceWorker';
import Messages from './theme/messages';

import { Provider } from 'react-redux';
import store from './redux/store/store';

ReactDOM.render(
  <ConfigProvider locale={viVN}>
    <Provider store={store}>
      <App />
      <Messages/>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
